export const ADD_REGISTER = 'ADD_REGISTER'
export const REGISTER = 'REGISTER'
export const REGISTERS = 'REGISTER'
export const SET_REGISTER = 'SET_REGISTER'
export const SET_REGISTER_ID = 'SET_REGISTER_ID'
export const SET_REGISTERS = 'SET_REGISTERS'
